module.exports = __webpack_public_path__ + "img/1327172014.4a7afac3.jpg";